import { useCallback } from 'react';
import { useMantineColorScheme } from '@mantine/core';

import { useGeoMarkupStore } from '@/store';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { usersService } from '@/services/api';

/**
 * Hook that handles theme toggling with backend preference sync.
 * Toggles the Mantine color scheme and persists the preference
 * to the backend when the user is authenticated.
 */
export function useThemeToggle(): {
  colorScheme: string;
  handleThemeToggle: () => void;
} {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const isAuthenticated = useGeoMarkupStore(selectIsAuthenticated);
  const updateUserPreferences = useGeoMarkupStore(
    (state) => state.auth.updateUserPreferences
  );

  const handleThemeToggle = useCallback(() => {
    toggleColorScheme();

    if (isAuthenticated) {
      const newTheme = colorScheme === 'dark' ? 'light' : 'dark';
      usersService
        .updatePreferences({ preferredTheme: newTheme })
        .then(() => updateUserPreferences({ preferredTheme: newTheme }))
        .catch(console.error);
    }
  }, [toggleColorScheme, isAuthenticated, colorScheme, updateUserPreferences]);

  return { colorScheme, handleThemeToggle };
}
